import React from 'react';
import PropTypes from 'prop-types';

import timeIcon from '../assets/images/icon-time.svg';
import playersIcon from '../assets/images/icon-players.svg';
import sadFaceIcon from '../assets/images/icon-sad.svg';

const BoardgameCard = (props) => {
  const onReserveButtonClicked = (event) => {
    props.onReserveBoardgame && props.onReserveBoardgame(props.id);
  };

  const onGetBackButtonClicked = (event) => {
    props.onGetBackBoardgame && props.onGetBackBoardgame(props.id);
  };

  return (
    <div className="md:w-2/5 lg:w-1/4 w-full flex-grow-0 rounded overflow-hidden shadow-lg mx-4 mb-10 bg-white">
      <div className="relative h-64 w-full">
        {
          (props.availableCopies === 0 || props.availableCopies === props.reservedCopies) &&
            <div className="absolute h-full w-full flex flex-col justify-center items-center">
              <div className="absolute h-full w-full bg-gray-700 opacity-75"></div>
              <img className="w-1/3 z-1" src={sadFaceIcon} alt="Il gioco non è disponibile..." />
              <p className="text-white z-10 px-10 text-center mt-4">Purtroppo questo gioco è già occupato.</p>
            </div>
        }
        <div className="h-64 w-full flex-none bg-cover bg-no-repeat bg-top text-center overflow-hidden"
            style={{backgroundImage: `url('${props.image}')`}} title={props.title}>
        </div>
      </div>
      <div className="px-6 py-4">
        <div className="font-bold text-xl mb-2">{ props.title }</div>
        <p className="text-gray-darker text-base">
          { props.description }
        </p>
      </div>
      <div className="flex justify-center mt-4 pb-4">
        <div className="pl-6 pr-2">
          <p className="text-sm flex items-center">
            <img className="mr-1" src={timeIcon} alt="Tempo di gioco" />
            { props.minPlayTime } { props.maxPlayTime ? `- ${props.maxPlayTime} min.` : 'min.' }
          </p>
        </div>
        <div className="pl-2 pr-6">
          <p className="text-sm flex items-center">
            <img className="mr-1" src={playersIcon} alt="Numero di giocatori" />
            { props.minPlayers } { props.maxPlayers ? ` - ${props.maxPlayers}` : '' }
          </p>
        </div>
      </div>
      {
        props.categories && props.categories.length > 0 && 
          <div className="px-6 pb-6 pt-2">
            {
              props.categories.map(category => 
                <span key={category.id} className="inline-block bg-gray-200 rounded-full mt-1 px-3 py-1 text-sm font-semibold text-gray-800 mr-2">
                  { category.name }
                </span>
              )
            }
          </div>
      }
      {
        props.showActions && <div className="flex justify-center mt-1 mb-4">
          <p className="text-sm flex items-center">
            Copie disponibili: { props.availableCopies - (props.reservedCopies || 0) }
          </p>
        </div>
      }
      { props.showActions && <div className="flex justify-center mt-6 mb-4">
        <button className={`bg-gray-300 hover:bg-gray text-gray-600 font-bold py-2 px-4 rounded-l ${ props.availableCopies === props.reservedCopies ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer' }`}
                type="button"
                disabled={props.availableCopies === props.reservedCopies}
                onClick={onReserveButtonClicked}>
          Riserva
        </button>
        <button className={`bg-gray-300 hover:bg-gray text-gray-600 font-bold py-2 px-4 rounded-r ${ props.reservedCopies === 0 ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer' }`}
                type="button"
                disabled={props.reservedCopies === 0}
                onClick={onGetBackButtonClicked}>
          Restituisci
        </button>
      </div> }
    </div>
  );
};

BoardgameCard.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  image: PropTypes.string,
  description: PropTypes.string,
  minPlayTime: PropTypes.number.isRequired,
  maxPlayTime: PropTypes.number,
  minPlayers: PropTypes.number.isRequired,
  maxPlayers: PropTypes.number,
  categories: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  })),
  showActions: PropTypes.bool,
  availableCopies: PropTypes.number,
  reservedCopies: PropTypes.number,
  onReserveBoardgame: PropTypes.func,
  onGetBackBoardgame: PropTypes.func,
};

BoardgameCard.defaultProps = {
  categories: [],
  showActions: false,
  availableCopies: 0,
  reservedCopies: 0,
  onReserveBoardgame: () => {},
  onGetBackBoardgame: () => {},
};

export default BoardgameCard;